import * as fromDatatype from '../datatype-library/index';

export interface bl_dgmkt_schedule_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  name: fromDatatype.TextDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  schedule_type: fromDatatype.VarcharDatatypeInterface;
  value_string: fromDatatype.VarcharDatatypeInterface;
  event_time: fromDatatype.VarcharDatatypeInterface;
  event_date: fromDatatype.VarcharDatatypeInterface;
  start_datetime: fromDatatype.TimestampTzDatatypeInterface;
  end_datetime: fromDatatype.TimestampTzDatatypeInterface;
  repeat_interval: fromDatatype.IntegerDatatypeInterface;
  repeat_on_day: fromDatatype.IntegerDatatypeInterface;
  repeat_count: fromDatatype.IntegerDatatypeInterface;
}

export class bl_dgmkt_schedule_hdr_RowClass
  implements bl_dgmkt_schedule_hdr_RowInterface
{
  guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  name: fromDatatype.TextDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  schedule_type: fromDatatype.VarcharDatatypeInterface;
  value_string: fromDatatype.VarcharDatatypeInterface;
  event_time: fromDatatype.VarcharDatatypeInterface;
  event_date: fromDatatype.VarcharDatatypeInterface;
  start_datetime: fromDatatype.TimestampTzDatatypeInterface;
  end_datetime: fromDatatype.TimestampTzDatatypeInterface;
  repeat_interval: fromDatatype.IntegerDatatypeInterface;
  repeat_on_day: fromDatatype.IntegerDatatypeInterface;
  repeat_count: fromDatatype.IntegerDatatypeInterface;
}
